import React, { useState } from 'react';
import { PageHeader, Card, Btn } from '../../components/UI';
import { adminApi } from '../../utils/api';
import toast from 'react-hot-toast';

export default function AdminAnnouncements() {
  const [form, setForm] = useState({ title: '', message: '', target: 'all', send_email: false, show_dashboard: true });
  const [saving, setSaving] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      const { data } = await adminApi.post('/api/announcements', form);
      if (data?.success !== false) { toast.success('Announcement published!'); setSent(true); setForm({ title: '', message: '', target: 'all', send_email: false, show_dashboard: true }); setTimeout(() => setSent(false), 3000); }
      else toast.error('Error publishing');
    } catch { toast.error('Error publishing'); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <PageHeader title="Announcements" />
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
        <Card title="📣 Create Announcement">
          {sent && <div style={{ background: 'rgba(0,231,76,0.08)', border: '1px solid rgba(0,231,76,0.2)', borderRadius: 8, padding: 12, marginBottom: 16, fontSize: 13, color: 'var(--green)', textAlign: 'center' }}>✅ Announcement published successfully!</div>}
          <form onSubmit={submit}>
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 13, color: 'var(--text-secondary)', marginBottom: 6, fontWeight: 500 }}>Title *</label>
              <input value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} placeholder="e.g. New Feature Released!" required style={{ width: '100%', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, padding: '10px 14px', color: 'var(--text)', fontSize: 14 }} />
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 13, color: 'var(--text-secondary)', marginBottom: 6, fontWeight: 500 }}>Message *</label>
              <textarea value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} placeholder="Announcement details..." required style={{ width: '100%', height: 120, background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, padding: 12, color: 'var(--text)', resize: 'none', fontSize: 13 }} />
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 13, color: 'var(--text-secondary)', marginBottom: 6, fontWeight: 500 }}>Target Users</label>
              <select value={form.target} onChange={e => setForm({ ...form, target: e.target.value })} style={{ width: '100%', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, padding: '10px 14px', color: 'var(--text)', fontSize: 14 }}>
                <option value="all">All Users</option>
                <option value="starter">Starter Plan Only</option>
                <option value="growth">Growth Plan Only</option>
                <option value="pro">Pro Plan Only</option>
                <option value="enterprise">Enterprise Plan Only</option>
              </select>
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--text-secondary)', cursor: 'pointer', marginBottom: 16 }}>
              <input type="checkbox" checked={form.send_email} onChange={e => setForm({ ...form, send_email: e.target.checked })} />
              Send via Email to targeted users
            </label>
            <Btn type="submit" disabled={saving} full>{saving ? 'Publishing...' : '📣 Publish Announcement'}</Btn>
          </form>
        </Card>
        <Card title="ℹ️ How It Works">
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {[['📣 Create', 'Write a title and message for your announcement.'], ['🎯 Target', 'Choose which plan users should see it.'], ['👁 Show Dashboard', 'Announcement shows on client dashboard.'], ['📧 Email (Optional)', 'Optionally send email to all targeted users.']].map(([icon, desc]) => (
              <div key={icon} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                <span style={{ fontSize: 20 }}>{icon.split(' ')[0]}</span>
                <div><div style={{ fontWeight: 600, fontSize: 13, marginBottom: 2 }}>{icon.split(' ').slice(1).join(' ')}</div><div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{desc}</div></div>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}